module.exports = __webpack_public_path__ + "static/media/customized-solutions-worker-laptop-factory.bb2f54a5.png";